import {
  Popup,
  Subnavbar,
  Page,
  Navbar,
  List,
  ListItem,
  Searchbar,
  AccordionContent,
  Link,
  NavRight,
} from "framework7-react";
import * as React from "react";
import { API_URL, CLOUD_FUNCTION } from "src/utils/constants";
import { EventEmmiter } from "src/utils/events.js";
import { getToken, api } from "src/utils/utils";

export default class ListProductsCompete extends React.Component<{}> {
  public state = {
    loading: false as boolean,
    data: [] as any[],
  };

  public cajas = [
    {
      name: "1 PZA A",
      texture: "1_pza_amarilla.jpg",
    },
    {
      name: "2 PZA A",
      texture: "2_pza_amarilla.jpg",
    },
    {
      name: "3 PZA A",
      texture: "3_pza_amarilla.jpg",
    },
    {
      name: "5 PZA A",
      texture: "5_pza_amarilla.jpg",
    },
    {
      name: "10 PZA A",
      texture: "10_pza_amarilla.jpg",
    },
    {
      name: "12 PZA A",
      texture: "12_pzas_amarilla.jpg",
    },
    {
      name: "15 PZA A",
      texture: "15_pzas_amarilla.jpg",
    },
    {
      name: "18 PZA A",
      texture: "18_pzas_amarilla.jpg",
    },
    {
      name: "20 PZA A",
      texture: "20_pzas_amarilla.jpg",
    },
    {
      name: "25 PZA A",
      texture: "25_pzas_amarilla.jpg",
    },
    {
      name: "30 PZA A",
      texture: "30_pzas_amarilla.jpg",
    },
    {
      name: "40 PZA A",
      texture: "40_pzas_amarilla.jpg",
    },
    {
      name: "50 PZA A",
      texture: "50_pzas_amarilla.jpg",
    },

    {
      name: "1 PZA V",
      texture: "1_pza_verde.jpg",
    },
    {
      name: "2 PZA V",
      texture: "2_pza_verde.jpg",
    },
    {
      name: "3 PZA V",
      texture: "3_pza_verde.jpg",
    },
    {
      name: "4 PZA V",
      texture: "4_pza_verde.jpg",
    },
    {
      name: "10 PZA V",
      texture: "10_pza_verde.jpg",
    },
    {
      name: "12 PZA V",
      texture: "12_pzas_verde.jpg",
    },
    {
      name: "15 PZA V",
      texture: "15_pzas_verde.jpg",
    },
    {
      name: "18 PZA V",
      texture: "18_pzas_verde.jpg",
    },
    {
      name: "20 PZA V",
      texture: "20_pzas_verde.jpg",
    },
    {
      name: "25 PZA V",
      texture: "25_pzas_verde.jpg",
    },
    {
      name: "30 PZA V",
      texture: "30_pzas_verde.jpg",
    },
    {
      name: "40 PZA V",
      texture: "40_pzas_verde.jpg",
    },
    {
      name: "50 PZA V",
      texture: "50_pzas_verde.jpg",
    },
  ];

  public product: any;
  public componentDidMount() {
    this.$f7?.tooltip.create({
      targetEl: ".closePopup",
      text: "Cancelar y Cerrar",
    });
    this.handleData();

    EventEmmiter.subscribe("select_category_box", (product: any) => {
      this.product = product;
      this.setState({
        loading: false,
      });
      this.$f7?.popup.open(".products-compete-popup");
    });
  }

  public async handleData() {
    if (getToken() == null) {
      return;
    }

    this.setState({
      loading: true,
    });
    // const dialog = this.$f7?.dialog.preloader("Cargando base de datos");
    // dialog?.open();

    const data = await api.get<any[]>(
      API_URL + CLOUD_FUNCTION + "getDataBase",
      {}
    );

    this.setState({
      data,
      loading: false,
    });

    // setTimeout(() => {
    //   dialog?.close();
    // }, 500);
  }

  public render() {
    return (
      <Popup className="products-compete-popup" closeByBackdropClick={false}>
        <Page>
          <Navbar title="Productos Internos">
            <Subnavbar>
              <Searchbar
                searchContainer=".search-list"
                searchIn=".item-title"
                placeHolder="Buscar"
              />
            </Subnavbar>
            <NavRight>
              <Link className="closePopup" popupClose=".products-compete-popup">
                <i className="icon icon-x" />
              </Link>
            </NavRight>
          </Navbar>
          <br />
          <br />
          <List className="searchbar-not-found bg-white">
            <ListItem title="No se encontraron resultados" />
          </List>
          <List className="search-list searchbar-found bg-white" accordionList>
            {this.state.data.length &&
              this.state.data.map((item: any) => {
                return (
                  <ListItem
                    accordionItem
                    key={item.id}
                    title={
                      item[0] +
                      " - " +
                      item[1] +
                      " - " +
                      item[2] +
                      " - " +
                      item[3]
                    }
                  >
                    <AccordionContent>
                      <div className="boxes">
                        {this.cajas &&
                          this.cajas.map((caja: any) => {
                            return (
                              <div
                                key={caja.id}
                                className={
                                  this.product &&
                                  this.product.category_box === caja.name &&
                                  this.product.internal_id === item[0]
                                    ? "box active"
                                    : "box"
                                }
                                hidden={this.checkAviableBoxOption(caja, item)}
                                onClick={(e: any) => {
                                  const data = { caja, item };
                                  EventEmmiter.dispatch(
                                    "category_box_selected",
                                    data
                                  );
                                  this.$f7?.popup.close(
                                    ".products-compete-popup"
                                  );
                                }}
                              >
                                <div className="title">
                                  <img src={"src/cajas/" + caja.texture} />
                                  <span>{caja.name}</span>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </AccordionContent>
                  </ListItem>
                );
              })}
          </List>
        </Page>
      </Popup>
    );
  }

  /*
    0 = RENGLON
    1 = CLAVE INKPRIMELO
    2 = NOMBRE
    3 = CODIGO AMARILLO 
    4 = CODIGO VERDE
    5 = 1
    6 = 2
    7 = 3
    8 = 5
    9 = 10
    10 = 12
    11 = 15
    12 = 18
    13 = 20
    14 = 24
    15 = 25
    16 = 30
    17 = 40
    18 = 50
  */
  public checkAviableBoxOption(caja: any, item: any): boolean {
    const color = caja.name.indexOf("PZA A") > -1 ? "A" : "V";
    const noPzas = caja.name.split(" ")[0];
    const isA = item[3] + "." === "." ? false : true;
    const isV = item[4] + "." === "." ? false : true;

    let ret = true;
    // YEELOW ?
    if (color === "A" && isA) {
      ret = this.getNoPzas(Number(noPzas), item);
    } else if (color === "V" && isV) {
      ret = this.getNoPzas(Number(noPzas), item);
    }

    return ret;
  }

  public getNoPzas(noPzas: number, item: any): boolean {
    if (noPzas === 1 && item[5] === "O") {
      return false;
    } else if (noPzas === 2 && item[6] === "O") {
      return false;
    } else if (noPzas === 3 && item[7] === "O") {
      return false;
    } else if (noPzas === 5 && item[8] === "O") {
      return false;
    } else if (noPzas === 10 && item[9] === "O") {
      return false;
    } else if (noPzas === 12 && item[10] === "O") {
      return false;
    } else if (noPzas === 15 && item[11] === "O") {
      return false;
    } else if (noPzas === 18 && item[12] === "O") {
      return false;
    } else if (noPzas === 20 && item[13] === "O") {
      return false;
    } else if (noPzas === 24 && item[14] === "O") {
      return false;
    } else if (noPzas === 25 && item[15] === "O") {
      return false;
    } else if (noPzas === 30 && item[16] === "O") {
      return false;
    } else if (noPzas === 40 && item[17] === "O") {
      return false;
    } else if (noPzas === 50 && item[18] === "O") {
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/prefabs/ListProductsCompete.tsx